/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb85Inputs */

const en__field_enum_pbs_fb85 = /** @type {(inputs: _Field_Enum_Pbs_Fb85Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 08 Faculty of Philosophy and History`)
};

const de__field_enum_pbs_fb85 = /** @type {(inputs: _Field_Enum_Pbs_Fb85Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 08 Philosophie und Geschichtswissenschaften`)
};

/**
* | output |
* | --- |
* | "F 08 Faculty of Philosophy and History" |
*
* @param {_Field_Enum_Pbs_Fb85Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb85 = /** @type {((inputs?: _Field_Enum_Pbs_Fb85Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb85Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb85(inputs)
	return de__field_enum_pbs_fb85(inputs)
});
export { _field_enum_pbs_fb85 as "_field_enum_PBS_FB8" }